import { isEmptyObject } from '@/common/converter/utils/is-empty-object'
import { DEVICE_TYPE_ANDROID } from '@/common/devicetype.const'
import {
  PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE,
  PRODUCT_TYPE_SUBSCRIPTION,
} from '@/common/constant'
import { FIRST_MONTH_PROMOTION_CONFIRM } from '@/common/resources/const'
import { normalizePurchaseParams } from '@/common/util/braze.util'
import { voucherPurchase } from '@/common/util/common'
import { voucherModalManager } from '@/common/util/voucher/voucher-modal-manager'

const CALLBACK_ACTION = `purchaseComplete`

export const handleVoucher = () => {
  const { openModal, closeLayerPopup, waitForEvent } = voucherModalManager()

  const closePopup = () => closeLayerPopup

  // modals
  const modal = {
    openPromotionCancel: (voucherInfo = {}) => {
      openModal.promotion({
        voucherInfo,
        component: () =>
          import('@/views/popup/popups/FirstMonthPromotionCancel.vue'),
      })
    },
    openPromotion(voucherInfo = {}) {
      openModal.promotion({
        isCloseButton: true,
        voucherInfo,
        component: () => import('@/views/popup/popups/FirstMonthPromotion.vue'),
      })
    },
  }

  const action = {
    // 100 원 프로모션 해지 경고 모달
    promotionCancelNotificationModal: async (voucherInfo = {}) => {
      modal.openPromotionCancel(voucherInfo)

      const { isSuccess } = await waitForSuccessEvent()
      if (isSuccess) {
        onShowBillingPopup(voucherInfo)
      }
    },

    // 100 원 프로모션 모달
    promotionModal: async (voucherInfo = {}) => {
      modal.openPromotion(voucherInfo)

      const { isSuccess, payloads } = await waitForSuccessEvent()
      if (isSuccess) {
        const { voucherInfo: newVoucherInfo } = payloads ?? {}
        onShowBillingPopup(newVoucherInfo)
      }
    },
  }

  /**
   * 모달 confirm success 유무를 프로미스로 리턴,
   * 리턴 전 로직이 필요 할 경우 callback (handler) 에서 처리
   * @returns {Promise<*>|Promise}
   */
  const waitForSuccessEvent = () => {
    return waitForEvent(FIRST_MONTH_PROMOTION_CONFIRM, (payload) => {
      if (!payload?.isSuccess) {
        return { isSuccess: false, payloads: undefined }
      }

      closeLayerPopup()
      return { isSuccess: true, payloads: payload?.payloads }
    })
  }

  /**
   * 외부 링크 voucher 구매 (제휴)
   * @param voucherInfo
   * @returns {undefined}
   */
  const onExternalPurchase = (voucherInfo, device) => {
    if (isEmptyObject(voucherInfo)) {
      return undefined
    }

    const concurrency = voucherInfo?.concurrency?.[0] ?? {}
    const linkTarget = concurrency?.external_link_target ?? ''
    const externalUrl = concurrency?.external_link_mobile ?? ''
    const externalLinkAndroid = concurrency?.external_link_android ?? ''

    if (device === DEVICE_TYPE_ANDROID) {
      return (location.href = externalLinkAndroid)
    }

    return window.open(externalUrl, linkTarget)
  }

  /**
   * 결제 팝업 띄우기 (pay letter)
   * @param voucherInfo
   */
  const onShowBillingPopup = ({ voucher, productInfo, device, pgName }) => {
    const productId = productInfo?.productid ?? ''
    const concurrency = voucher?.concurrency?.[0] ?? {}

    const productTypeForGoogleIAP =
      pgName === PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE
        ? PRODUCT_TYPE_SUBSCRIPTION
        : ''
    const callbackParams = {
      next: 'setData',
      ...normalizePurchaseParams({
        ...concurrency,
        ...productInfo,
      }),
    }

    voucherPurchase({
      deviceType: device,
      productId,
      callbackAction: CALLBACK_ACTION,
      callbackParams,
      canceledCallbackAction: 'Cancel',
      pgName: pgName,
      productTypeForGoogleIAP,
    })
  }

  return {
    modal,
    action,
    closePopup,
    onExternalPurchase,
    onShowBillingPopup,
  }
}
